import * as types from '../constants';

const initialState = {
  loading: true,
  messageLoading: true,
  ticketsOpened: {},
  ticketsClosed: {},
  ticketDetails: {},
  count: 0,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_TICKETS_OPENED_START:
      return {
        ...state,
        loading: true,
        ticketsOpened: {},
      };

    case types.FETCH_TICKETS_OPENED_SUCCESS:
      return {
        ...state,
        loading: false,
        ticketsOpened: action.payload,
      };

    case types.FETCH_TICKETS_OPENED_FAILURE:
      return {
        ...state,
        loading: true,
        err: action.err,
      };

    case types.FETCH_TICKETS_CLOSED_START:
      return {
        ...state,
        loading: true,
        ticketsClosed: {},
      };

    case types.FETCH_TICKETS_CLOSED_SUCCESS:
      return {
        ...state,
        loading: false,
        ticketsClosed: action.payload,
      };

    case types.FETCH_TICKETS_CLOSED_FAILURE:
      return {
        ...state,
        loading: true,
        err: action.err,
      };

    case types.FETCH_TICKET_DETAILS_START:
      return {
        ...state,
        loading: true,
        messageLoading: true,
        ticketDetails: {}
      };

    case types.FETCH_TICKET_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        messageLoading: false,
        ticketDetails: action.payload
      };

    case types.FETCH_TICKET_DETAILS_FAILURE:
      return {
        ...state,
        loading: true,
        messageLoading: true,
        err: action.err
      };

    case types.ADD_TICKET_MESSAGE_START:
      return {
        ...state,
        messageLoading: true,
      };

    case types.ADD_TICKET_MESSAGE_SUCCESS:
      return {
        ...state,
        messageLoading: false,
      };

    case types.ADD_TICKET_MESSAGE_FAILURE:
      return {
        ...state,
        messageLoading: true,
      };

    case types.FETCH_NEW_TICKETS_START:
      return {
        ...state,
        count: [],
      };

    case types.FETCH_NEW_TICKETS_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };

    case types.FETCH_NEW_TICKETS_FAILURE:
      return {
        ...state,
        err: action.err,
      };

    default:
      return state;
  }
};

export default reducer;
